import { useMemo, memo, useContext } from "react";
import { useSeetingsViewModel } from "../../viewModel/useSettingsViewModel";
import { ChildrenContainer, FullPageContainer } from "./Default.style";

import { MenuLayout, usesSidebarLayout } from "../../viewModel/strategy/menu/MenuLayout/menuLayout.strategy";
import { useAuth } from "../../templates/AuthGate";
import { TenantContext } from "../../templates/context/TenantContext"

import PropTypes from "prop-types";

export const Default = memo(function Default({ children, fullPage = false, tenantOverride }) {

  const { tenant } = useAuth();
  const tenantContext = useContext(TenantContext);

  const vm = useSeetingsViewModel({
    shouldFetchUserCtx: tenant?.name?.toLowerCase() === 'buffon',
    shouldFetchStores: tenant?.name?.toLowerCase() === 'buffon'
  });

  const headerCtx = useMemo(
    () => ({
      userRole: vm?.ctx.userRole,
      tenantContext: tenantContext || {}
    }),
    [vm?.ctx.userRole, tenantContext]
  );

  return (
    <>
      <MenuLayout
        tenant={tenant}
        ctx={headerCtx}
        tenantOverride={tenantOverride}
      />

      {fullPage ? (
        <FullPageContainer $hasFixedSidebar={usesSidebarLayout(tenant?.name)}>{children}</FullPageContainer>
      ) : (
        <ChildrenContainer>{children}</ChildrenContainer>
      )}
    </>
  );
});

Default.propTypes = {
  children: PropTypes.node.isRequired,
  fullPage: PropTypes.bool,
  tenantOverride: PropTypes.string,
}